import { IntroMessages } from 'TutorBotVoiceAgent';
import './locales/TutorBotCoach/CoachIntro-en.json';
import { useTranslation } from 'react-i18next';
import { type FC, memo } from 'react';
import { Card } from 'Card';
import { Text } from 'Text';

const IntroLocales = [{ key: 'join_a_session' }, { key: 'it_is_a_chance_to' }, { key: 'find_a_quiet_spot' }];

const CoachIntroComponent: FC = () => {
    const { t } = useTranslation('back_royal', {
        keyPrefix: 'TutorBotCoach.CoachIntro',
    });

    return (
        <>
            <div className="absolute top-20 z-10 flex w-full justify-center">
                <Card width={342} header={<Text as="h2">{t('thank_you_for_applying')}</Text>}>
                    <Text as="p">{t('we_have_received_your_submission')}</Text>
                </Card>
            </div>
            <div className="absolute bottom-0 z-0">
                <IntroMessages messages={IntroLocales} t={t} />
            </div>
        </>
    );
};

export const CoachIntro = memo(CoachIntroComponent) as typeof CoachIntroComponent;
